<template>
    <div class="personal-page">
        <div style="width: 100%; height: 65px; position: fixed; background-color: black;"></div>
        <!-- 顶部个人卡片 -->
        <section class="profile-hero">
            <div class="container hero-grid">
                <div class="avatar">
                    <img :src="$store.state.dlMark!==null?$store.state.dlMark.touxiang:''" alt="avatar" />

                </div>
                <div class="profile">
                    <div class="name-row">
                        <h1 class="nickname">{{ $store.state.dlMark.nicheng }}</h1>
                        <!-- <span class="badge">音漫创作者</span> -->
                    </div>
                    <p class="bio">{{ $store.state.dlMark.content }}</p>
                    <!-- <div class="tags">
                        <span class="tag">🎵 {{ user.tags.music }}</span>
                        <span class="tag">📚 {{ user.tags.comic }}</span>
                        <span class="tag">✨ {{ user.tags.style }}</span>
                    </div> -->
                </div>
                <div class="stats">
                    <!-- <div class="stat">
                        <div class="num">{{ formatNumber(user.stats.works) }}</div>
                        <div class="label">作品</div>
                    </div>
                    <div class="stat">
                        <div class="num">{{ formatNumber(user.stats.likes) }}</div>
                        <div class="label">获赞</div>
                    </div>
                    <div class="stat">
                        <div class="num">{{ formatNumber(user.stats.followers) }}</div>
                        <div class="label">粉丝</div>
                    </div> -->
                    <div class="stat coin">
                        <div class="num">{{ $store.state.dlMark.money }}<span class="coin-unit"> 硬币</span></div>
                        <router-link class="link" to="/topUp">充值</router-link>
                    </div>
                </div>
            </div>
        </section>

        <!-- 选项卡 -->
        <section class="tabs">
            <div class="container tabs-bar">
                <div class="tab-list">
                    <button v-for="t in tabs" :key="t.key" :class="['tab', { active: activeTab === t.key }]"
                        @click="activeTab = t.key">
                        <span class="icon" v-html="t.icon"></span>
                        <span>{{ t.label }}</span>
                    </button>
                </div>
                <div class="actions">
                    <button class="btn ghost" @click="editProfile">退出登录</button>
                    <!-- <router-link class="btn primary">上传音乐</router-link> -->
                </div>
            </div>
        </section>

        <!-- 内容区 -->
        <section class="content">
            <div class="container content-grid">
                <!-- 左列：卡片列表 -->
                <div class="main">
                    <!-- 概览 -->
                    <div v-if="activeTab === 'overview'" class="panel-list">
                        <div class="panel highlight">
                            <h3 class="panel-title">创作概览</h3>
                            <div class="overview-grid">
                                <div class="ov-item">
                                    <div class="ov-icon music">🎵</div>
                                    <div>
                                        <div class="ov-num">{{ formatNumber(user.stats.musicCount) }}</div>
                                        <div class="ov-label">音乐素材</div>
                                    </div>
                                </div>
                                <div class="ov-item">
                                    <div class="ov-icon comic">📚</div>
                                    <div>
                                        <div class="ov-num">{{ formatNumber(user.stats.comicCount) }}</div>
                                        <div class="ov-label">漫画章节</div>
                                    </div>
                                </div>
                                <div class="ov-item">
                                    <div class="ov-icon like">❤</div>
                                    <div>
                                        <div class="ov-num">{{ formatNumber(user.stats.likes) }}</div>
                                        <div class="ov-label">累计获赞</div>
                                    </div>
                                </div>
                                <div class="ov-item">
                                    <div class="ov-icon play">▶</div>
                                    <div>
                                        <div class="ov-num">{{ formatNumber(user.stats.plays) }}</div>
                                        <div class="ov-label">总播放/阅读</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel">
                            <h3 class="panel-title">最近动态</h3>
                            <div class="feed">
                                <div v-for="(f, idx) in feed" :key="idx" class="feed-item">
                                    <div class="feed-cover" :style="{ backgroundImage: f.cover }"></div>
                                    <div class="feed-body">
                                        <div class="feed-title">{{ f.title }}</div>
                                        <div class="feed-meta">{{ f.type }} · {{ f.time }}</div>
                                    </div>
                                    <div class="feed-stats">
                                        <span>▶ {{ formatNumber(f.play) }}</span>
                                        <span>❤ {{ formatNumber(f.like) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 我的音乐 -->
                    <div v-if="activeTab === 'music'" class="card-grid">
                        <div v-for="(m,index) in music" :key="m.id" class="card">
                            <div class="card-cover">
                                <img :src="m.image_urls" alt="">
                            </div>
                            <audio ref="bfaudio" :src="m.url"></audio>
                            <div class="card-info" style="position: relative;">
                                <div class="card-title">{{ m.name }}</div>
                                <div class="card-sub">{{ m.singer }}</div>
                                <div class="card-meta" style="position: absolute; right: 20px; z-index: 10;bottom: 20px;"
                                @click="Dianjibf(m,index)">
                                    <img style="width: 25px; height: 25px; cursor: pointer;" v-show="!m.isPlaying" src="../../../assets/image/hei_bf.png" alt="">
                                    <img style="width: 20px; height: 20px; cursor: pointer;" v-show="m.isPlaying" src="../../../assets/image/hei_zt.png" alt="">
                                </div>
                            </div>
                        </div>
                        <p class="Kong_p" v-show="music.length==0">您还没有下载音乐，快去下载吧！</p>
                    </div>

                    <!-- 我的漫画 -->
                    <div v-if="activeTab === 'comic'" class="card-grid" style="grid-template-columns: repeat(4, 1fr);">
                        <div v-for="c in comics" :key="c.id" class="card" style="height: 360px; cursor: pointer;"
                        @click="Manhua_op(c)">
                            <div class="card-cover" style="height: 80%;">
                                <img style="width: 100%; height: 100%; object-fit: cover;" :src="c.image" alt="">
                            </div>
                            <div class="card-info">
                                <div class="card-title">{{ c.name }}</div>
                                <div class="card-sub" style="
                                width: 100%;
                                overflow: hidden;
                                white-space:nowrap;
                                text-overflow: ellipsis;
                                ">{{ c.content }}</div>
                            </div>
                        </div>
                        <p class="Kong_p" v-show="comics==null">您还没有收藏漫画，快去收藏吧！</p>
                        
                    </div>

                    <!-- 订单与资产 -->
                    <div v-if="activeTab === 'orders'" class="panel">
                        <h3 class="panel-title">购买记录</h3>
                        <div class="asset">
                            <!-- <div class="asset-balance">
                                <div class="amount">{{ $store.state.dlMark.money }}</div>
                                <div class="unit">硬币</div>
                                <router-link to="/topUp" class="btn primary small">去充值</router-link>
                            </div> -->
                            <div class="asset-list">
                                <div v-for="(o, idx) in orders" :key="idx" class="order-item">
                                    <div class="order-left">
                                        <div class="order-title">{{ o.name }} · {{ o.type=='漫画'?'第'+o.huashu+'话':o.singer }}</div>
                                        <div class="order-meta">{{ o.type }} · {{ o.createtime }}</div>
                                    </div>
                                    <div class="order-right">
                                        <span class="order-coin">-{{ o.type=='漫画'?'300':o.price }}</span>
                                        <span class="order-status" :class="o.status">已完成</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 设置 -->
                    <div v-if="activeTab === 'settings'" class="panel">
                        <h3 class="panel-title">账户设置</h3>
                        <div class="form-grid">
                            <div class="form-item">
                                <label>昵称</label>
                                <input v-model="user.nickname" type="text" />
                            </div>
                            <div class="form-item">
                                <label>个人简介</label>
                                <textarea v-model="user.bio" rows="3"></textarea>
                            </div>
                            <div class="form-item">
                                <label>旧密码</label>
                                <input v-model="user.jiuMima" type="password" />
                            </div>
                            <div class="form-item">
                                <label>新密码</label>
                                <input v-model="user.xinMima" type="password" />
                            </div>
                            <div class="form-actions">
                                <button class="btn primary" @click="saveSettings">保存修改</button>
                                <button class="btn ghost" @click="resetSettings">重置</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右列：侧边建议 -->
                <aside class="aside">
                    <div class="aside-card">
                        <h4>为你推荐 · 音乐</h4>
                        <div class="aside-list">
                            <div v-for="(r, idx) in recommendMusic" :key="idx" class="aside-item">
                                <div class="dot dot-music"></div>
                                <div class="text">
                                    <div class="t-title">{{ r.title }}</div>
                                    <div class="t-sub">{{ r.desc }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="aside-card">
                        <h4>为你推荐 · 漫画</h4>
                        <div class="aside-list">
                            <div v-for="(r, idx) in recommendComics" :key="idx" class="aside-item">
                                <div class="dot dot-comic"></div>
                                <div class="text">
                                    <div class="t-title">{{ r.title }}</div>
                                    <div class="t-sub">{{ r.desc }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            avatar: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop stop-color="%23667eea"/><stop offset="1" stop-color="%23764ba2"/></linearGradient></defs><rect width="200" height="200" rx="100" fill="url(%23g)"/><circle cx="100" cy="80" r="34" fill="%23fff" opacity=".96"/><rect x="40" y="120" width="120" height="56" rx="28" fill="%23fff" opacity=".96"/></svg>',
            activeTab: 'music',
            user: {
                nickname: '',
                bio: '',
                jiuMima:'',
                xinMima:'',
                balance: 280,
                stats: {
                    works: 47,
                    likes: 12600,
                    followers: 2380,
                    plays: 982000,
                    musicCount: 23,
                    comicCount: 12
                },
                tags: {
                    music: '流行 / 电子 / 轻氛围',
                    comic: '热血 / 科幻 / 青春',
                    style: '治愈 · 赛博 · 极简'
                }
            },
            tabs: [
                // { key: 'overview', label: '概览', icon: '' },
                { key: 'music', label: '已下载', icon: '🎵' },
                { key: 'comic', label: '我的收藏', icon: '📚' },
                { key: 'orders', label: '购买记录', icon: '💰' },
                { key: 'settings', label: '设置', icon: '⚙️' }
            ],
            feed: [
                { title: '发布音乐 · 星空漫游 BGM', type: '音乐', time: '2 小时前', play: 3200, like: 180, cover: "linear-gradient(120deg,#a78bfa,#60a5fa)" },
                { title: '更新漫画 · 赛博之城 第 12 话', type: '漫画', time: '昨天', play: 8900, like: 640, cover: "linear-gradient(120deg,#06b6d4,#22c55e)" },
                { title: '音乐上架 · 光之彼端 OST', type: '音乐', time: '3 天前', play: 12100, like: 920, cover: "linear-gradient(120deg,#f59e0b,#ef4444)" }
            ],
            music:[],
            comics:[],
            orders: [],
            recommendMusic: [
                { title: '清风入弦', desc: '轻柔钢琴 · 学习专注' },
                { title: '逐电狂潮', desc: '电子能量 · 跑步健身' }
            ],
            recommendComics: [
                { title: '风起云涌', desc: '热血冒险 · 高燃回归' },
                { title: '星光书页', desc: '治愈日常 · 温暖相伴' }
            ]
        }
    },
    mounted(){
        //音乐
        const data1 ={
            yhname:this.$store.state.dlMark.username
        }
        axios.post('/api/index/musicxs',data1).then(res=>{
            console.log('音乐',res.data.data);
            this.music = res.data.data.map(scc => ({
                ...scc,
                isPlaying: false
            }));
        }).catch(err=>{
            console.log(err);
        })
        //漫画
        const data2 ={
            yhname:this.$store.state.dlMark.username
        }
        axios.post('/api/index/comicxs',data2).then(res=>{
            console.log('漫画',res.data.data);
            this.comics = res.data.data;
        }).catch(err=>{
            console.log(err);
        });

        //购买记录
        const data3 ={
            yhname:this.$store.state.dlMark.username
        }
        axios.post('/api/index/goumaimusicc',data3).then(res=>{
            console.log('购买记录',res.data.data);
            this.orders = res.data.data.sort_related;
            this.orders.push(...res.data.data.music_related);
        }).catch(err=>{
            console.log(err);
        })
        
    },
    methods: {
        formatNumber(n) {
            if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
            if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
            return n
        },
        //点击播放
        Dianjibf(m,index){
            this.music.forEach((otherItem, otherindex) => {
                if (otherItem.isPlaying && otherindex !== index) {
                    otherItem.isPlaying = false; // 更新状态
                    const suoyou = this.$refs.bfaudio[index];
                    suoyou.pause();
                }
            });
             const Caudio = this.$refs.bfaudio[index];
            if(m.isPlaying){
                m.isPlaying = false;
                Caudio.pause()
            }else{
                m.isPlaying = true;
                Caudio.play().catch(err => {
                    // 捕获播放失败错误（比如视频加载失败）
                    console.log('视频播放失败：', err);
                });
            }
        },
        //退出登录
        editProfile() {
            if(this.$store.state.dlMark!==null){
                localStorage.removeItem('zqW');
                this.$store.state.dlMark = null;
                this.$router.push('/')
            }              
        },
        saveSettings() {
            const data = {
                yhname:this.$store.state.dlMark.username,
                nicheng:this.user.nickname,
                content:this.user.bio,
                pastpwd:this.user.jiuMima,
                newpwd:this.user.xinMima,
            }
            axios.post('/api/index/xiugaizl',data).then(res=>{
                console.log(res)
                if(res.data.code==1){
                    this.$message.success('修改成功！请重新登录')
                    this.editProfile();
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //点击进入详情页漫画
        Manhua_op(m){
            this.$router.push({
                name:'Nxiangqing',
                params:{
                    name:m.name
                }
            })
        },
        resetSettings() {
            this.$forceUpdate()
        }
    }
}
</script>

<style scoped lang="scss">
.Kong_p{
    position: absolute;
    color: #7f7f7f;
    font-size: 22px;
}
.personal-page {
    background: #fff;
    color: #0f172a;
    min-height: 100vh;
}

.container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 16px;
}

/* 顶部个人卡片 */
.profile-hero {
    padding: 92px 0 18px;
    border-bottom: 1px solid #f1f5f9;
    background: #fff;
}

.hero-grid {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 18px;
    align-items: center;
}

.avatar img {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    box-shadow: 0 8px 24px rgba(2, 8, 23, .12);
}

.profile .name-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.nickname {
    margin: 0;
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -.3px;
}

.badge {
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    color: #4f46e5;
    background: #eef2ff;
    border: 1px solid #e0e7ff;
}

.bio {
    margin: 6px 0 10px;
    color: #475569;
}

.tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.tag {
    padding: 6px 10px;
    border-radius: 999px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #334155;
    font-size: 12px;
}

.stats {
    display: flex;
    gap: 16px;
}

.stat {
    min-width: 100px;
    padding: 10px 12px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    text-align: center;
}

.stat .num {
    font-size: 18px;
    font-weight: 800;
    color: #0f172a;
}

.stat .label {
    font-size: 12px;
    color: #64748b;
}

.stat.coin .num {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.stat.coin .coin-unit {
    font-size: 12px;
    color: #64748b;
    font-weight: 600;
}

.stat .link {
    display: inline-flex;
    margin-top: 6px;
    font-size: 12px;
    color: #667eea;
    text-decoration: none;
}

/* 选项卡 */
.tabs {
    background: #fff;
    border-bottom: 1px solid #f1f5f9;
}

.tabs-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
}

.tab-list {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.tab {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #0f172a;
    cursor: pointer;
    font-weight: 700;
}

.tab.active,
.tab:hover {
    background: #343180;
    color: #fff;
    border-color: transparent;
}

.tab .icon {
    font-size: 16px;
}

.actions {
    display: flex;
    gap: 10px;
}

.btn {
    height: 36px;
    padding: 0 14px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #0f172a;
    cursor: pointer;
    font-weight: 700;
    transition: 0.2s;
}

.btn.primary {
    background: #667eea;
    border-color: #667eea;
    color: #fff;
}

.btn.ghost:hover {
    border-color: #94a3b8;
    background-color: #94a3b81b;
}
.btn.ghost:active {
    transform: scale(0.97);
}

.btn.small {
    height: 32px;
    padding: 0 10px;
}

/* 内容区布局 */
.content {
    padding: 18px 0 80px;
    background: #fff;
}

.content-grid {
    display: grid;
    grid-template-columns: 1.6fr .8fr;
    gap: 18px;
}

/* 面板与卡片 */
.panel {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    position: relative;
}

.panel.highlight {
    background: linear-gradient(180deg, #ffffff, #f8fafc);
    border-color: #e5e7eb;
}

.panel-title {
    margin: 0 0 12px;
    font-size: 16px;
    color: #0f172a;
    font-weight: 800;
}

.overview-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
}

.ov-item {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
}

.ov-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
}

.ov-icon.music {
    background: #eef2ff;
    color: #4f46e5;
}

.ov-icon.comic {
    background: #ecfeff;
    color: #0ea5e9;
}

.ov-icon.like {
    background: #fff1f2;
    color: #ef4444;
}

.ov-icon.play {
    background: #ecfdf5;
    color: #10b981;
}

.ov-num {
    font-size: 18px;
    font-weight: 800;
    color: #0f172a;
}

.ov-label {
    font-size: 12px;
    color: #64748b;
}

.feed {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.feed-item {
    display: grid;
    grid-template-columns: 120px 1fr auto;
    gap: 12px;
    align-items: center;
    padding: 10px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
}

.feed-cover {
    width: 120px;
    height: 72px;
    border-radius: 10px;
    background-size: cover;
    background-position: center;
}

.feed-title {
    font-weight: 700;
    color: #0f172a;
}

.feed-meta {
    font-size: 12px;
    color: #64748b;
    margin-top: 4px;
}

.feed-stats {
    display: flex;
    gap: 12px;
    color: #475569;
    font-size: 12px;
}

.card-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    position: relative;
}

.card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
    transition: transform .2s ease, box-shadow .2s ease;
}

.card:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 36px rgba(2, 8, 23, .06);
}

.card-cover {
    height: 128px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    position: relative;
}

.badge.corner {
    position: absolute;
    top: 8px;
    left: 8px;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 999px;
    color: #4f46e5;
    background: #eef2ff;
    border: 1px solid #e0e7ff;
}

.badge.corner.alt {
    color: #0ea5e9;
    background: #ecfeff;
    border-color: #bae6fd;
}

.card-info {
    padding: 12px;
}

.card-title {
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 4px;
}

.card-sub {
    font-size: 12px;
    color: #64748b;
}

.card-meta {
    margin-top: 8px;
    display: flex;
    gap: 12px;
    font-size: 12px;
    color: #475569;
}

.asset {
    gap: 14px;
}

.asset-balance {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px;
    text-align: center;
    background: #fff;
}

.asset-balance .amount {
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
}

.asset-balance .unit {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 8px;
}

.asset-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.order-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
}

.order-title {
    font-weight: 700;
    color: #0f172a;
}

.order-meta {
    font-size: 12px;
    color: #64748b;
    margin-top: 4px;
}

.order-coin {
    color: #ef4444;
    font-weight: 800;
}

.order-status {
    font-size: 12px;
    padding: 3px 8px;
    border-radius: 999px;
    margin-left: 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #475569;
}

.order-status.done {
    background: #ecfdf5;
    border-color: #bbf7d0;
    color: #16a34a;
}

.order-status.refund {
    background: #fff7ed;
    border-color: #fed7aa;
    color: #f97316;
}

/* 侧栏 */
.aside {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.aside-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
    padding: 14px;
}

.aside-card h4 {
    margin: 0 0 10px;
    font-size: 14px;
    color: #0f172a;
}

.aside-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.aside-item {
    display: flex;
    gap: 10px;
    align-items: center;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.dot-music {
    background: #6366f1;
}

.dot-comic {
    background: #06b6d4;
}

.t-title {
    font-size: 13px;
    color: #0f172a;
    font-weight: 700;
}

.t-sub {
    font-size: 12px;
    color: #64748b;
}

/* 表单 */
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.form-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-item label {
    font-size: 12px;
    color: #475569;
}

.form-item input,
.form-item textarea {
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    outline: none;
    background: #fff;
    color: #0f172a;
}

.form-item input:focus,
.form-item textarea:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 4px rgba(102, 126, 234, .12);
}

.form-actions {
    grid-column: 1 / -1;
    display: flex;
    gap: 10px;
    margin-top: 4px;
}

/* 响应式 */
@media (max-width: 1024px) {
    .content-grid {
        grid-template-columns: 1fr;
    }

    .asset {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 720px) {
    .hero-grid {
        grid-template-columns: auto 1fr;
    }

    .stats {
        grid-column: 1 / -1;
    }

    .card-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 480px) {
    .card-grid {
        grid-template-columns: 1fr;
    }
}
</style>
